import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-password-field',
  templateUrl: './password-field.component.html',
  styleUrls: ['./password-field.component.scss']
})
export class PasswordFieldComponent implements OnInit {
  @Input() id: string;
  @Input() value: string;
  @Input() requirements: PasswordRequirements;

  @Output() valueChange = new EventEmitter<string>();
  @Output() keyboardEnter = new EventEmitter<void>();

  get isLengthRequired(): boolean {
    return this.requirements.minLength > 0 || this.requirements.maxLength > 0;
  }

  get isLengthValid(): boolean {
    return this.value.length >= this.requirements.minLength && this.value.length <= this.requirements.maxLength;
  }

  get isUppercaseRequired(): boolean {
    return this.requirements.minUppercase > 0;
  }

  get isUppercaseValid(): boolean {
    return this.value.match(/[A-Z]/g) != null && this.value.match(/[A-Z]/g).length >= this.requirements.minUppercase;
  }

  get isLowercaseRequired(): boolean {
    return this.requirements.minLowercase > 0;
  }

  get isLowercaseValid(): boolean {
    return this.value.match(/[a-z]/g) != null && this.value.match(/[a-z]/g).length >= this.requirements.minLowercase;
  }

  get isDigitRequired(): boolean {
    return this.requirements.minDigits > 0;
  }

  get isDigitValid(): boolean {
    return this.value.match(/[0-9]/g) != null && this.value.match(/[0-9]/g).length >= this.requirements.minDigits;
  }

  get isSpecialCharacterRequired(): boolean {
    return this.requirements.minSpecial > 0;
  }

  get isSpecialCharacterValid(): boolean {
    return this.value.match(/[^a-zA-Z0-9]/g) != null && this.value.match(/[^a-zA-Z0-9]/g).length >= this.requirements.minSpecial;
  }

  getPluralSuffixIfRequired(count: number): string {
    return count > 1 ? 's' : '';
  }

  constructor() { }

  ngOnInit(): void {
    if (!this.requirements) {
      this.requirements = PasswordRequirements.getDefault();
    }
  }

  setValue(value: string) {
    this.value = value;
    this.valueChange.emit(value);
  }

  onKeyup(event: Event) {
    this.keyboardEnter.emit();
  }

  isValid() {
    return this.isLengthValid && this.isUppercaseValid && this.isLowercaseValid && this.isDigitValid && this.isSpecialCharacterValid;
  }
}

export class PasswordRequirements {
  minLength: number;
  maxLength: number;
  minUppercase: number;
  minLowercase: number;
  minDigits: number;
  minSpecial: number;

  static getDefault(): PasswordRequirements {
    const requirements = new PasswordRequirements();
    requirements.minLength = 6;
    requirements.maxLength = 32;
    requirements.minUppercase = 1;
    requirements.minLowercase = 1;
    requirements.minDigits = 1;
    requirements.minSpecial = 1;
    return requirements;
  }
}
